import '../content/scss/vendor.scss';

import '@angular/common';
import '@angular/core';
import '@angular/forms';
import '@angular/platform-browser';
import '@ng-bootstrap/ng-bootstrap';
import 'ngx-cookie';
import 'jquery';
import 'bootstrap-sass';
import 'ng-jhipster';
import 'ngx-webstorage';
import 'ngx-quill';
import 'quill';
import 'rxjs';
import '@uirouter/angular';



// WEBPACK FOOTER //
// ./src/app/vendor-aot.ts